import { createBrowserRouter } from 'react-router-dom'

import { Login, Register } from '@/modules/Auth'
import { Landing } from '@/modules/Landing'
import { NotFound } from '@/modules/NotFound'
import { Conditions, KYC, Privacy, Refund } from '@/modules/Policy'
import {
  Affiliate,
  Home,
  Order,
  OrderPayment,
  Orders,
  Settings,
  Verify,
  Wallet,
  WalletReceive,
  WalletSend,
} from '@/modules/Profile'

import { PrivateRoute } from './PrivateRoute'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Landing />,
  },

  {
    path: '/login',
    element: <Login />,
  },

  {
    path: '/register',
    element: <Register />,
  },

  {
    path: '/terms-and-conditions',
    element: <Conditions />,
  },

  {
    path: '/kyc-aml-policy',
    element: <KYC />,
  },

  {
    path: '/privacy-policy',
    element: <Privacy />,
  },

  {
    path: '/refund-policy',
    element: <Refund />,
  },

  {
    path: '/c',
    element: <PrivateRoute />,
    children: [
      {
        path: '',
        element: <Home />,
      },
      {
        path: 'wallets/:code',
        element: <Wallet />,
      },
      {
        path: 'wallets/:code/receive',
        element: <WalletReceive />,
      },
      {
        path: 'wallets/:code/send',
        element: <WalletSend />,
      },
      {
        path: 'orders',
        element: <Orders />,
      },
      {
        path: 'orders/:id',
        element: <Order />,
      },
      {
        path: 'orders/:id/payment',
        element: <OrderPayment />,
      },
      {
        path: 'affiliate',
        element: <Affiliate />,
      },
      {
        path: 'settings',
        element: <Settings />,
      },
      {
        path: 'verify',
        element: <Verify />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },

  {
    path: '*',
    element: <NotFound />,
  },
])
